import React from 'react';
import { motion } from 'framer-motion';
export const Experience = () => {
  const experiences = [{
    title: 'The Room',
    image: 'https://images.unsplash.com/photo-1519834785169-98be25ec3f84?w=1950&q=80',
    description: "A warm, welcoming space built for worship. As voices rise in praise, the atmosphere comes alive. Lights glow, colors shift, and God's presence fills the room."
  }, {
    title: 'The Song',
    image: 'https://cdn.magicpatterns.com/uploads/8pFHptdHASP1mQaCuJppRT/Christian-Womens-Small-Group-Ideas.webp',
    description: 'Gospel hymns, worship songs, and praise anthems that lift the spirit. Each song is chosen to inspire worship, reflection, and joy. No performance pressure, just pure praise.'
  }, {
    title: 'The Praise',
    image: 'https://images.unsplash.com/photo-1504052434569-70ad5836ab65?w=1950&q=80',
    description: 'As we worship together, something beautiful happens. Voices unite, hearts connect, and the room fills with the unmistakable presence of praise and fellowship.'
  }];
  return <section className="py-20 px-4 sm:px-6 lg:px-8 bg-gradient-to-b from-brand-charcoal to-brand-black" data-id="element-44">
      <div className="max-w-6xl mx-auto" data-id="element-45">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="text-center mb-16" data-id="element-46">
          <h2 className="font-display text-3xl sm:text-4xl font-bold mb-6 text-white" data-id="element-47">
            The Experience
          </h2>
          <div className="w-24 h-1 bg-brand-red mx-auto mb-10" data-id="element-48"></div>
          <p className="text-xl max-w-3xl mx-auto text-white/90" data-id="element-49">
            Step into a space designed for worship and fellowship. Where singing
            praise becomes a powerful, communal celebration of faith.
          </p>
        </motion.div>
        {experiences.map((exp, index) => <motion.div key={index} initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8,
        delay: index * 0.2
      }} className={`flex flex-col ${index % 2 === 1 ? 'md:flex-row-reverse' : 'md:flex-row'} gap-8 mb-16`} data-id="element-50">
            <div className="md:w-1/2" data-id="element-51">
              <div className="relative overflow-hidden rounded-lg h-80" data-id="element-52">
                <img src={exp.image} alt={exp.title} className="w-full h-full object-cover" data-id="element-53" />
                <div className="absolute inset-0 bg-black/30" data-id="element-54"></div>
                <motion.div className="absolute inset-0 bg-gradient-radial from-brand-red/20 via-transparent to-transparent" animate={{
              scale: [1, 1.2, 1],
              opacity: [0.1, 0.3, 0.1]
            }} transition={{
              duration: 8,
              repeat: Infinity,
              ease: 'easeInOut'
            }} data-id="element-55" />
              </div>
            </div>
            <div className="md:w-1/2 flex flex-col justify-center" data-id="element-56">
              <h3 className="font-display text-2xl font-bold mb-4 text-white" data-id="element-57">
                {exp.title}
              </h3>
              <p className="text-lg leading-relaxed text-white/80" data-id="element-58">
                {exp.description}
              </p>
            </div>
          </motion.div>)}
      </div>
    </section>;
};